import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(theme => {
  return {
    outerContainer: {
      paddingTop: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      paddingBottom: '4.5rem',
    },
    profileContainer: {
      display: 'flex',
      alignItems: 'center',
      textDecoration: 'none',
    },
    profileInnerContainer: {
      height: '40px',
      width: '40px',
    },
    profileImageError: {
      height: '40px',
      width: '40px',
      borderRadius: '100%',
      border: '1px solid rgba(0, 0, 0, 0.2)',
      textAlign: 'center',
    },
    profileImage: {
      height: '40px',
      width: '40px',
      borderRadius: '100%',
      border: '1px solid rgba(0, 0, 0, 0.2)',
    },
    nameContainer: {
      marginLeft: '0.5rem',
    },
    name: {
      fontSize: '1rem',
    },
    addButtonContainer: {
      marginTop: '10px',
      marginBottom: '10px',
      textAlign: 'right',
    },
    addButton: {
      position: 'absolute',
      marginLeft: '-8rem',
      marginTop: '1rem',
      zIndex: '1',
      textTransform: 'capitalize',
    },
  };
});
